import { get } from 'pc-sales/utils/http';
import server, { ServerApi } from './server';
import basicAccountType, { BasicAccountTypeApi } from './basicAccountType';

export {
    ServerApi,
    BasicAccountTypeApi
};
export class MtApi {
    server = server;           // 服务器设置
    basicAccountType = basicAccountType;

    // 获取可用交易平台
    platforms = () => get('/v2/platform/setting/getUsedTradePlatform');

    // 获取平台下服务器
    // servers = (data: {
    //     trade_platform: 'MT4' | 'MT5';
    // }) => get('/mt/getServer', data);
}

export default new MtApi();
